<template>
	<div class="dialog">
		<el-dialog title="人员名单" :visible.sync="isShowPerson" width="50%" :before-close="handleClose">
			<div class="table">
				<el-table :data="tableData" stripe height="500" style="width: 100%; "
					:header-cell-style="{background:'#F4F4F4',color:'#BB2916',textAlign:'center',}">
					<el-table-column prop="customerName" label="姓名">
					</el-table-column>
					<el-table-column prop="customerIdCard" label="证件号码">
					</el-table-column>
					<el-table-column prop="productName" label="门票名称">
					</el-table-column>
					<el-table-column prop="productPrice" label="票价">
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'PersonList',
		props: {
			isShowPerson: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				value: '',
			}
		},
		methods: {
			// 弹窗关闭时触发
			handleClose() {
				this.$emit('changeDialog', false);
			}
		},
	}
</script>

<style scoped>
	.table {
		height: 450px;
		overflow: auto;
	}

	/deep/ .el-dialog__header {
		height: 42px;
		background: #BB2916;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0 24px;
		box-sizing: border-box;
		justify-content: space-between;
	}

	/deep/ .el-dialog__body {
		padding: 32px;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__title {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF !important;
	}

	/deep/ .el-dialog__headerbtn {
		width: 16px;
		height: 16px;
		position: inherit;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #FFFFFF !important;
	}

	/deep/ .searchbox .el-input {
		width: 356px;
		height: 40px;
		color: #BB2916;
	}

	/deep/ .searchbox .el-input__inner {
		width: 356px;
		height: 40px;
		background: #ffffff;
		border: 1px solid #E9E9E9;
		border-radius: 10px;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #00AA7A;
	}

	/deep/.table .el-table__row .cell {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 400;
		color: #333333;
		text-align: center;
	}

	/deep/.table1 .el-table__row .cell {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 400;
		color: #999999;
		text-align: center;
	}

	/deep/ .el-table__row {
		height: 56px;
	}

	/deep/.table .el-table__row .el-table__cell:nth-child(7) .cell {
		font-weight: 600;
	}

	/deep/.table1 .el-table__row .el-table__cell:nth-child(7) .cell {
		font-weight: 600;
		color: #E34D59;
	}

	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background: #128468;
		border-color: #BB2916;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: unset;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #BB2916;
		border-color: #BB2916;
		border-color: #BB2916;
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #BB2916;
		border-color: #BB2916;
		border-color: #BB2916;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #BB2916;
	}

	/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #BB2916;
		border-color: #BB2916;
	}

	/deep/ .el-checkbox__inner:hover {
		border-color: #BB2916 !important;
	}
</style>
